import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Input,Button,Fa,CardImage,Card} from "mdbreact";
import {Link} from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';


import ContactMap from "../../components/map/ContactMap";

import "./../../assets/images/banner-contact.jpg";

const pageTitle = "تماس با ما";

export default class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            massage: ''
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.massage !== ""){
            toast.success('از شما بابت ارسال نظراتتان سپاسگذایم.', {position: toast.POSITION.TOP_LEFT});
        }else{
            toast.error('لطفا قبل از ارسال فیلد پیام را تکمیل کنید.', {position: toast.POSITION.TOP_LEFT});

        }

        /*axios.post('/contact',{name:this.state.name,email:this.state.email, massage:this.state.massage})
            .then(function(response){
                console.log(response);
            })*/
    }


    render() {
        return (
            <div >

                <div className="jumbotron text-center rtl contact-page-header">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">{pageTitle}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">

                        <div className="col-sm-12 mb-5" style={{minHeight:615}}>
                            <ContactMap />
                        </div>

                        <div className="col-md-6">
                            <Card cascade>
                                <CardImage tag="div">
                                    <div className="view gradient-card-header blue-gradient p-3" style={{backgroundColor:"#e9edef"}}>
                                        {/*<p><strong>آدرس:</strong></p>*/}
                                        <p><strong>تلفن:</strong> 021 12345678</p>
                                        <p><strong>فاکس:</strong> 021 12345678</p>
                                        <p><strong>ایمیل:</strong> <a href="mailTo:info@atldmo.ir">info@atldmo.ir</a></p>

                                    </div>
                                </CardImage>
                            </Card>
<br/>
<br/>
                            <Card cascade>
                                <CardImage tag="div">
                                    <div className="view gradient-card-header blue-gradient p-3" style={{backgroundColor:"#32039e", color:"#fff"}}>
                                        <h2 className="h2-responsive">نیاز به راهنمایی و آموزش دارید؟</h2>
                                        <p>جهت کسب اطلاعات بیشتر به بخش راهنمای استفاده مراجعه نمایید.</p>

                                        <Link to="/how-it-works"  className="btn btn-deep-orange" style={{fontWeight:"bold"}}>اطلاعات بیشتر</Link>
                                    </div>
                                </CardImage>

                            </Card>

                        </div>
                        <div className="col-md-6">
                            <h2 className="mb-5">با ما در تماس باشید</h2>
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <Input label="نام"  group type="text" validate error="wrong" success="right"  />
                                <Input label="ایمیل"  group type="email" validate error="wrong" success="right" value={this.state.email}  onChange={e => this.setState({ email: e.target.value })}/>
                                {/*<Input label="موضوع" group type="email" validate error="wrong" success="right"/>*/}
                                <Input type="textarea" label="پیام" value={this.state.massage} onChange={e => this.setState({ massage: e.target.value })}/>
                                <div className="text-left">
                                    <Button type="submit" value="Submit" color="deep-orange" style={{fontWeight:"bold"}}>ارسال <Fa icon="paper-plane-o" className="ml-1"/></Button>
                                </div>
                            </form>
                            <ToastContainer
                                hideProgressBar={true}
                                newestOnTop={true}
                                autoClose={5000}

                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/contact/ContactUs.js